<powerbi-report [embedConfig]="reportConfig" [cssClassName]="reportClass" >  </powerbi-report>